export enum SortingOrderE {
  Asc = 'Asc',
  Desc = 'Desc',
}
